(function () {
  if (!document.querySelector('media-gallery')) {
    document.addEventListener('shopify:section:load', function () {
      if (document.querySelector('media-gallery')) boot();
    });
    return;
  }
  boot();

  function boot() {
    var vsliderInstance = null;
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getVSliderContext() {
      var mg = document.querySelector('media-gallery');
      if (!mg) return null;
      return {
        desktopLayout: mg.dataset.galleryLayout || '',
        mobileLayout: mg.dataset.mobileMediaLayout || '',
        viewer: mg.querySelector('[id^="GalleryViewer"]'),
        mediaList: mg.querySelector('[id^="Slider-Gallery"]'),
        mediaItems: mg.querySelectorAll('.product__media-item'),
        pagination: mg.querySelector('.vslider-pagination'),
      };
    }

    function shouldActivate(ctx) {
      if (!ctx) return false;
      return mobileQuery.matches
        ? ctx.mobileLayout === 'custom-vertical-carousel'
        : ctx.desktopLayout === 'custom-vertical-carousel';
    }

    function activateVSlider(ctx) {
      if (vsliderInstance) return;

      var viewer = ctx.viewer;
      var mediaList = ctx.mediaList;
      var mediaItems = Array.from(ctx.mediaItems);
      var paginationContainer = ctx.pagination;

      if (!viewer || !mediaList || mediaItems.length === 0 || !paginationContainer) return;

      viewer.classList.add('vslider');
      mediaList.classList.add('vslider-track');
      mediaItems.forEach(function (item) { item.classList.add('vslide'); });

      paginationContainer.innerHTML = '';
      var index = 0;
      var isAnimating = false;
      var startY = 0, endY = 0;
      var transitionMs = reducedMotionQuery.matches ? 0 : 400;

      // Dots via DocumentFragment (single reflow)
      var fragment = document.createDocumentFragment();
      mediaItems.forEach(function (_, i) {
        var dot = document.createElement('div');
        dot.classList.add('dot');
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', function () { goToSlide(i); });
        fragment.appendChild(dot);
      });
      paginationContainer.appendChild(fragment);
      var dots = paginationContainer.querySelectorAll('.dot');

      function setContainerHeight() {
        var img = mediaItems[index] ? mediaItems[index].querySelector('img') : null;
        if (!img) return;
        if (img.complete && img.offsetHeight > 0) {
          viewer.style.height = img.offsetHeight + 'px';
        } else {
          img.addEventListener('load', function () {
            viewer.style.height = img.offsetHeight + 'px';
          }, { once: true });
        }
      }

      function goToSlide(newIndex) {
        if (isAnimating) return;
        index = newIndex;
        isAnimating = true;
        mediaList.style.transition = 'transform ' + transitionMs + 'ms ease-in-out';
        mediaList.style.transform = 'translateY(-' + mediaItems[index].offsetTop + 'px)';
        setContainerHeight();
        updateDots();
        setTimeout(function () { isAnimating = false; }, transitionMs);
      }

      function updateDots() {
        dots.forEach(function (dot, i) { dot.classList.toggle('active', i === index); });
      }

      function nextSlide() {
        goToSlide(index < mediaItems.length - 1 ? index + 1 : 0);
      }
      function prevSlide() {
        goToSlide(index > 0 ? index - 1 : mediaItems.length - 1);
      }

      // Wheel — desktop only, cached query
      function onWheel(event) {
        if (mobileQuery.matches) return;
        if (isAnimating) return;
        if (Math.abs(event.deltaY) < 10) return;
        event.preventDefault();
        if (event.deltaY > 0) nextSlide();
        else prevSlide();
      }

      // Touch/Drag — distance-based
      function dragStart(y) { startY = y; endY = y; }
      function dragMove(y) { endY = y; }
      function dragEnd() {
        var distance = endY - startY;
        if (Math.abs(distance) > 30 && !isAnimating) {
          if (distance < 0) nextSlide();
          else prevSlide();
        }
      }

      function onMousedown(e) { e.preventDefault(); dragStart(e.clientY); }
      function onMousemove(e) { dragMove(e.clientY); }
      function onMouseleave() { startY = endY = 0; }
      function onTouchstart(e) { dragStart(e.touches[0].clientY); }
      function onTouchmove(e) { dragMove(e.touches[0].clientY); }

      // Keyboard accessibility
      function onKeydown(e) {
        if (e.key === 'ArrowDown') nextSlide();
        if (e.key === 'ArrowUp') prevSlide();
      }

      viewer.addEventListener('wheel', onWheel, { passive: false });
      viewer.addEventListener('mousedown', onMousedown);
      viewer.addEventListener('mousemove', onMousemove);
      viewer.addEventListener('mouseup', dragEnd);
      viewer.addEventListener('mouseleave', onMouseleave);
      viewer.addEventListener('touchstart', onTouchstart);
      viewer.addEventListener('touchmove', onTouchmove);
      viewer.addEventListener('touchend', dragEnd);
      viewer.addEventListener('keydown', onKeydown);
      viewer.setAttribute('tabindex', '0');

      // Initial height: set instantly (no transition) to avoid layout shift
      viewer.style.transition = 'none';
      setContainerHeight();
      void viewer.offsetHeight; // force reflow
      viewer.style.transition = '';

      // Debounced resize
      var resizeTimeout;
      function onResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setContainerHeight, 150);
      }
      window.addEventListener('resize', onResize);

      vsliderInstance = {
        destroy: function () {
          viewer.removeEventListener('wheel', onWheel);
          viewer.removeEventListener('mousedown', onMousedown);
          viewer.removeEventListener('mousemove', onMousemove);
          viewer.removeEventListener('mouseup', dragEnd);
          viewer.removeEventListener('mouseleave', onMouseleave);
          viewer.removeEventListener('touchstart', onTouchstart);
          viewer.removeEventListener('touchmove', onTouchmove);
          viewer.removeEventListener('touchend', dragEnd);
          viewer.removeEventListener('keydown', onKeydown);
          window.removeEventListener('resize', onResize);
          viewer.removeAttribute('tabindex');
          viewer.style.height = '';
          mediaList.style.transform = '';
          mediaList.style.transition = '';
          paginationContainer.innerHTML = '';
          viewer.classList.remove('vslider');
          mediaList.classList.remove('vslider-track');
          mediaItems.forEach(function (item) { item.classList.remove('vslide'); });
          vsliderInstance = null;
        }
      };
    }

    function updateVSlider() {
      var ctx = getVSliderContext();
      if (!ctx) return;
      if (shouldActivate(ctx)) activateVSlider(ctx);
      else if (vsliderInstance) vsliderInstance.destroy();
    }

    // DOMContentLoaded instead of load (~1-3s faster)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateVSlider);
    } else {
      updateVSlider();
    }

    document.addEventListener('shopify:section:load', updateVSlider);
    mobileQuery.addEventListener('change', updateVSlider);

    window.updateVSlider = updateVSlider;
    window.destroyVSlider = function () {
      if (vsliderInstance) vsliderInstance.destroy();
    };
  }
})();
